import axios from "axios";

export type GetBookingSegmentsReturn = {
    code: string,
    label: string
}[]

export const getBookingSegments =  async (req?: { tenants: string[], dealers: string[] }): Promise<GetBookingSegmentsReturn> => {
    const response = await axios.get('/booking/search/segments', { params:{
        tenants: req?.tenants.join(",") || "",
        dealers: req?.dealers.join(",") || "",
    } });
    return response.data;
};